<template>
  <div class="upload system-upload-file">
    <div class="form-label"><span class="text-star" style="color:#71110e">* </span>{{ $t('merchantAccount.signature_of_the_beneficiary') }}</div>
    <div v-if="absolutePath !== null && isImg(absolutePath)">
      <img v-viewer class="content-img reply-content-img mt-12" :src="absolutePath" alt="">
      <el-link v-if="!disabled" style="margin-top: -24px" type="primary" @click="deleteImg">
        {{ $t('components.delete') }}
      </el-link>
    </div>
    <div v-else>
      <el-button class="mt-12" type="primary" @click="showModal">{{ $t('merchantAccount.click_to_sign') }}</el-button>
    </div>
    <el-dialog style="text-align: center" :visible.sync="dialogVisibleFile" :close-on-click-modal="false" :modal="false" class="diglog-card" width="800px" height="500px" @close="dialogVisibleFile = false">
      <div>
        <canvas ref="canvas" style="margin-top: -20px;margin-bottom: 30px;background-color: #efefef" />
        <br>
        <el-button class="clear-btn" @click="clearSignature">
          {{ $t('components.clear') }}
        </el-button>
        <el-button type="primary" class="clear-btn" @click="handleFile">
          {{ $t('components.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadFileWithProgress } from '@/api/components/upload'
import SmoothSignature from 'smooth-signature'
export default {
  name: 'UpdateFile',
  components: {
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      removeFiles: [],
      uploadingProgress: 0,
      uploading: false,
      dialogVisibleFile: false, // 控制弹框显示隐藏
      filePath: '',
      fileName: '',
      absolutePath: null
    }
  },
  methods: {
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    },
    showModal() {
      this.dialogVisibleFile = true
      this.$nextTick(this.initCanvas)
    },
    addOssUrl(row) {
      this.absolutePath = row
    },
    initCanvas() {
      this.signature = new SmoothSignature(this.$refs.canvas, {
        width: 700,
        height: 400,
        scale: 1,
        minWidth: 1,
        maxWidth: 3,
        color: '#0054F0',
        bgColor: 'rgba(255,255,255,0)'
      })
    },
    clearSignature() {
      this.signature.clear()
    },
    deleteImg() {
      this.absolutePath = null
    },
    handleFile() {
      if (this.signature.isEmpty()) {
        this.$message.warning('Please sign by hand!')
        return
      } else {
        const base64 = this.signature.getPNG()
        const data = window.atob(base64.split(',')[1])
        const ia = new Uint8Array(data.length)
        for (let i = 0; i < data.length; i++) {
          ia[i] = data.charCodeAt(i)
        }
        const blob = new Blob([ia], { type: 'image/png' })
        const fd = new FormData()
        fd.append('file', blob, Date.now() + '.png')
        fd.append('business', 'WALLET_USER_INFO')
        uploadFileWithProgress({ data: fd }).then(res => {
          const { path, absolutePath, ...otherData } = res.data
          this.filePath = path
          this.fileName = Date.now() + '.png'
          this.absolutePath = absolutePath
          this.$emit('uploadFileSuccess', { fileName: this.fileName, filePath: this.filePath })
          this.dialogVisibleFile = false
          this.clearSignature()
        })
      }
    },
    removeUploadFile(type = '', file) {
      const uid = file.uid
      if (!this.$refs['upload_' + type]) {
        return
      }
      const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
      if (idx !== -1) {
        this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
      }
    },
    handleRemove(type, file, fileList) {
      this.fileList = fileList
      if (file.status === 'ready') {
        this.uploadingProgress = 0
        this.uploading = false
        this.removeFiles.push(file.uid)
      }
    },
    handleFileExceed(type) {
      if (this.fileList[type].length >= this.limitNum) {
        this.$message.warning(`The current limit is ${this.limitNum}, please delete and upload again!`)
        return
      }
    }
  }
}
</script>
<style>
.system-upload-file .el-upload-dragger{
  width: 450px;
  height: 130px;
}
.system-upload-file .el-icon-upload{
    font-size: 34px;
    color: #D3D7DF;
    margin: 28px 0 16px;
    line-height: 1;
}
</style>

<style lang="scss" scoped>
.system-upload-file .diglog-card ::v-deep .el-dialog__header{
  border: none
}
.upload{
  display: inline-block;
}
.btn-update{
  margin-left: 10px;
}
.upload-container{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    cursor: pointer;
    line-height: 100px;
    vertical-align: top;
    font-size: 12px;
    color: #8c939d;
    .icon-add{
      font-size: 8px;
    }
}
.parse{
    width: 600px;
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
}
.form-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #364250;
}
.content-img{
  cursor: pointer;
  height: 100px;
  width: 175px;
}
.reply-content-img{
  margin-bottom: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-12 {
  margin-top: 12px;
}
</style>
